import {forwardRef} from 'react'
import {
  Modal as GWCModal,
  ModalProps as GWCModalProps,
  ModalBodyProps as GWCModalBodyProps,
  ModalHeaderProps as GWCModalHeaderProps
} from '@gwc/core'
import clsx from 'clsx'

import {classes} from './Modal.classes'
import {SidePanel} from './SidePanel'

export type ModalProps = Omit<GWCModalProps<'div'>, 'ref' | 'key'>

const Modal = Object.assign(
  function Modalv2({
    disableAutoFocus = true,
    enableFocusOutside = true,
    className,
    children,
    onClose,
    backdrop = {},
    ...props
  }: ModalProps) {
    return (
      <GWCModal<'div'>
        {...props}
        backdrop={
          typeof backdrop === 'boolean'
            ? backdrop
            : {
                // @ts-expect-error "не понимается data-testid"
                'data-testid': 'modal.backdrop_click',
                ...backdrop,
                className: clsx(backdrop?.className, classes.backdrop),
              }
        }
        className={clsx(className, classes.modal)}
        disableAutoFocus={disableAutoFocus}
        enableFocusOutside={enableFocusOutside}
        onClose={onClose}
      >
        {children}
      </GWCModal>
    )
  },
  {
    Title: GWCModal.Title,
    Header: forwardRef<HTMLDivElement, React.PropsWithChildren<GWCModalHeaderProps>>(function (props, ref) {
      return <GWCModal.Header {...props} className={clsx(props.className, classes.modalHeader)} ref={ref}  />
    }),
    Body: forwardRef<HTMLDivElement, React.PropsWithChildren<GWCModalBodyProps>>(function (props, ref) {
      return <GWCModal.Body {...props} className={clsx(props.className, classes.modalBody)} ref={ref} />
    }),
    Footer: GWCModal.Footer,
    SidePanel,
  },
)

export default Modal
